import React from 'react'
import './StepOnePage.scss'
import { Label } from 'reactstrap'
import { Button, Input } from 'antd'
import { ArrowRightOutlined, PlusOutlined } from '@ant-design/icons'
import { useState } from 'react'
import TrashIcon from "../../../assets/images/trash-blue.svg"

const StepOnePage = ({ next }) => {
    const [founders, setFounders] = useState([{}]);

    const addFounder = () => {
        setFounders([...founders, {}]); // push a new founder object
    };
    const removeFounder = (indexToRemove) => {
        console.log({ indexToRemove })
        setFounders(prev => prev.filter((_, idx) => idx !== indexToRemove));
    };
    return (
        <div className='step1-section'>
            <h1>Who are the <strong>founders ?</strong></h1>
            {founders.map((_, index) => (
                <FounderComponent key={index} index={index} removeFounder={removeFounder}
                    showRemove={founders.length > 1} />
            ))}

            <Button
                className="add-founder-button"
                onClick={addFounder}
            >
                <strong>
                    <PlusOutlined />
                </strong>
                Add Another Founder
            </Button>
            <Button
                // loading={authLoading}
                // disabled={!isEnabled}
                onClick={next}
                className="continue-button"
            >
                Continue <ArrowRightOutlined />
            </Button>
        </div>
    )
}

export default StepOnePage


const FounderComponent = ({ index, removeFounder, showRemove }) => {
    const { TextArea } = Input;
    return (
        <div className="founder-component-section">
            <div className='top-section'>
                <h2>Founder {index + 1}</h2>
                {showRemove && <img src={TrashIcon} alt="TrashIcon" onClick={() => removeFounder(index)} />}

            </div>
            <div className="founder-form">
                <div className="form-field">
                    <Label>Full Name</Label>
                    <Input className="text-field-input"
                        placeholder="John Smith  "
                        name="full-name"
                        type="text" />
                </div>
                <div className="form-field">
                    <Label>Email Address</Label>
                    <Input className="text-field-input"
                        placeholder="johnsmith123@gmail.com "
                        name="email-address"
                        type="email" />
                </div>
                <div className="form-field">
                    <Label>Role and Skillset</Label>
                    <TextArea rows={4} className="textarea-field-input"
                        placeholder="CFO; Strong background in finance, fundraising, and financial modeling for non-profits.  "
                        name="role-skillset"
                        type="textarea" />
                </div>
            </div>
        </div>
    )
}